<mat-form-field class="input-container" [floatLabel]="floatLabel">
  <mat-label *ngIf="label != null">{{label}}</mat-label>
  <input matInput maxlength="100" class="ng-untouched ng-pristine ng-valid" *ngIf="formControl" [formControl]="formControl"
    [name]="name" [matAutocomplete]="autocomplete" [placeholder]="placeholder" (keyup)="onKey($event)"
    (focus)="onFocus($event)" (blur)="onBlur($event)" required #autocompleteInput />
  <input matInput maxlength="100" class="ng-untouched ng-pristine ng-valid" *ngIf="!formControl" [name]="name"
    [matAutocomplete]="autocomplete" [placeholder]="placeholder" (keyup)="onKey($event)" (focus)="onFocus($event)" (blur)="onBlur($event)" #autocompleteInput />
  <button *ngIf="selectedOption || query" mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearValue()" #clearButton type="button">
    <mat-icon class="clear-icon">clear</mat-icon>
  </button>
  <mat-progress-bar mode="indeterminate" *ngIf="hasProgressBar && requestsInQueue > 0"></mat-progress-bar>
  <mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="autocompleteDisplayFn()" (optionSelected)="autocompleteSelected($event)">
    <mat-option title="{{viewItem(item)}}" *ngFor="let item of autocompleteList" [value]="item">
      <ng-template [ngIf]="displayTemplate">
        <ng-container *ngTemplateOutlet="displayTemplate; context: {$implicit: item}"></ng-container>
      </ng-template>
      <span *ngIf="!displayTemplate">
        {{viewItem(item)}}
      </span>
    </mat-option>
    <mat-option *ngIf="query && noSuggestions" disabled>
      <span>{{'autocomplete.suggestion' | translate }}</span>
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="formControl && validation && formControl.invalid" [id]="name">{{getErrorMessage()}}</mat-error>
</mat-form-field>
